export const POSTCODE_REGEXES: RegExp[] = [
  /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-Z][A-Z]){1}$/i,
  /^JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  /^GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/,
  /^([0-9]{5})(?:-([0-9]{4}))?$/,
  /^([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ])\s*([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])$/i,
  /^([AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/,
  /^\d{3}-\d{4}$/,
  /^\d{2}[ ]?\d{3}$/,
  /^\d{4}$/,
  /^\d{5}$/,
  /^(?!0)\d{4}$/,
  /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/,
  /^\d{4}[ ]?[A-Z]{2}$/,
  /^(SE-)?\d{3}[ ]?\d{2}$/,
  /^\d{5}[\-]?\d{3}$/,
  /^\d{4}([\-]\d{3})?$/,
  /^(FI-|AX-)?\d{5}$/,
  /^22\d{3}$/,
  /^\d{3}(\d{2,3})?$/,
  /^[A-HJ-NP-Z]\d{4}([A-Z]{3})?$/,
  /^(37)?\d{4}$/,
  /^((1[0-2]|[2-9])\d{2})?$/,
  /^(BB\d{5})?$/,
  /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/,
  /^BBND 1ZZ$/,
  /^[A-Z]{2}[ ]?\d{4}$/,
  /^\d{7}$/,
  /^(\d{4,5}|\d{3}-\d{4})$/,
  /^(HR-)?\d{5}$/,
  /^\d{3}[ ]?\d{2}$/,
  /^([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/,
  /^39\d{2}$/,
  /^(?:\d{5})?$/,
  /^\d{3}$/,
  /^\d{6}$/,
  /^\d{5,7}$/,
  /^KY[123]-\d{4}$/,
  /^(LV-)?\d{4}$/,
  /^(\d{4}([ ]?\d{4})?)?$/,
  /^(948[5-9])|(949[0-7])$/,
  /^(LT-)?\d{5}$/,
  /^(L-)?\d{4}$/,
  /^[A-Z]{3}[ ]?\d{2,4}$/,
  /^((\d|[A-Z])\d{4})?$/,
  /^980\d{2}$/,
  /^((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?$/,
  /^(\d{6})?$/,
  /^(PC )?\d{3}$/,
  /^969[67]\d([ \-]\d{4})?$/,
  /^9695[012]([ \-]\d{4})?$/,
  /^9[78]2\d{2}$/,
  /^988\d{2}$/,
  /^008(([0-4]\d)|(5[01]))([ \-]\d{4})?$/
];
